import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useContext } from 'react';
export const InlineMultiDatePickerContext = createContext(undefined);
export const InlineMultiDatePickerProvider = props => {
    const [selectedDates, setSelectedDates] = useState([]);
    const [lastSelectedDate, setLastSelectedDate] = useState();
    const update = (date) => {
        if (!selectedDates.map((date) => date.getTime()).includes(date.getTime())) {
            const newDates = [...selectedDates, date];
            setSelectedDates(newDates);
            setLastSelectedDate(lastSelectedDate);
        }
        else {
            const newDates = [...selectedDates.filter((d) => d.getTime() !== date.getTime())];
            setSelectedDates(newDates);
        }
    };
    return (_jsx(InlineMultiDatePickerContext.Provider, Object.assign({ value: {
            selectedDates: selectedDates,
            lastSelectedDate: lastSelectedDate,
            update: update,
            clear: () => setSelectedDates([]),
        } }, { children: props.children })));
};
export const useInlineMultiDatePickerContext = () => {
    const context = useContext(InlineMultiDatePickerContext);
    if (context === undefined)
        throw new Error('No InlineMultiDatePickerContext is provided');
    return context;
};
